module.exports = __webpack_public_path__ + "images/ing_smalleca5bbc63034fa0dd68d6751c0de3d4a.png";